import { ContextModules, SetupAssistantForm } from "@pages/project/activities/setupAssistant/setupAssistant.types";
import { finishValidationSchema } from "@pages/project/activities/setupAssistant/setupAssistantUtils";
import { Formik, Form } from "formik";
import { SetupAssistantFormContent } from "@pages/project/activities/setupAssistant/components/SetupAssistantFormContent";
import { FinalForm } from "@pages/project/activities/setupAssistant/SetupAssistantFinish";
import { Tab } from "./EditActivityCombined";
import EditHeaderButtons from "./EditHeaderButtons";

interface EditModulesProps {
  modules: ContextModules[];
  values: SetupAssistantForm;
  initialValues: FinalForm;
  handleSubmit: (values: FinalForm) => void;
  modulesInput: any;
  isEdit: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  isError: boolean;
  errorMsg: string;
  showConfirmModal: boolean;
  handleCancel: () => void;
  handleConfirm: (submitForm: () => Promise<void>) => void;
  setShouldBlockTabs?: (shouldBlock: boolean) => void;
  handleTabChange: (tab: Tab) => void;
}

const EditModules = ({ initialValues, handleSubmit, modulesInput, isEdit, isLoading, isSubmitting, isError, errorMsg, showConfirmModal, handleCancel, handleConfirm, setShouldBlockTabs, handleTabChange }: EditModulesProps) => {
  return (
    <section style={{ height: '100%', overflow: 'auto' }}>
      <div className="module-group ms-3">
        <div className="pos-relative mb-2 pb-1 d-flex f-column justify-content-center gap-8">
          <h2 className="fs-14 ff-medium-ext module-header w-fit">
            Edit Activity Modules
          </h2>
          <EditHeaderButtons handleTabChange={handleTabChange} tab={Tab.Modules} />
        </div>

        <div className="d-flex f-column pt-1" style={{ maxWidth: "700px" }}>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={handleSubmit}
            validationSchema={finishValidationSchema}
          >
            {({ isValid, submitForm, errors, touched, dirty }) => {
              if (setShouldBlockTabs) setShouldBlockTabs(dirty && Object.keys(touched).length > 0);

              return (
                <Form>
                  <SetupAssistantFormContent
                    modulesInput={modulesInput}
                    isEdit={isEdit}
                    isLoading={isLoading}
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                    isError={isError}
                    errorMsg={errorMsg}
                    showConfirmModal={showConfirmModal}
                    errors={errors}
                    touched={touched}
                    onCancel={handleCancel}
                    onConfirm={handleConfirm}
                    submitForm={submitForm}
                  />
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </section>
  );
}

export default EditModules;
